import React from 'react';
import { motion } from 'motion/react';
import { Zap, Globe, CheckCircle2 } from 'lucide-react';
import { usePageTitle } from '../lib/usePageTitle';

export const AboutPage: React.FC = () => {
  usePageTitle('QuantumHire - Focussed Full-time Hiring Platform');
  return (
    <div className="min-h-screen bg-white pt-28 sm:pt-40 pb-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-brand-primary/5 text-brand-primary text-[10px] font-black uppercase tracking-[0.2em] mb-8 border border-brand-primary/10">
            Our Mission
          </span>
          <h1 className="text-5xl md:text-7xl font-display font-bold text-brand-primary mb-12 tracking-tight leading-[0.95]">
            A New Model <br />for Hiring
          </h1>

          <div className="space-y-12 text-xl text-brand-muted leading-relaxed font-medium">
            <p className="text-brand-primary text-2xl font-semibold opacity-90 border-l-4 border-brand-accent pl-8 py-2">
              QuantumHire is an outcome-driven hiring platform that combines AI-powered technology with recruitment execution.
            </p>
            
            <div className="grid md:grid-cols-2 gap-12 pt-8">
              <div className="space-y-4">
                <div className="w-12 h-12 bg-gray-50 rounded-2xl flex items-center justify-center border border-gray-100">
                  <Zap className="w-6 h-6 text-brand-primary" />
                </div>
                <h3 className="text-xl font-bold text-brand-primary">Recruitment Execution</h3>
                <p className="text-sm font-medium">
                  We help organizations hire faster by managing sourcing, screening, and shortlisting — while aligning pricing to successful hires.
                </p>
              </div>
              <div className="space-y-4">
                <div className="w-12 h-12 bg-gray-50 rounded-2xl flex items-center justify-center border border-gray-100">
                  <Globe className="w-6 h-6 text-brand-primary" />
                </div>
                <h3 className="text-xl font-bold text-brand-primary">Universal Reach</h3>
                <p className="text-sm font-medium">
                  Built to work across roles, industries, and geographies, QuantumHire brings structure, speed, and accountability to hiring.
                </p>
              </div>
            </div>

            <div className="pt-12 border-t border-gray-100">
              <div className="space-y-6">
                {[
                  "Outcome-driven alignment",
                  "Neural matching engine",
                  "Expert talent partners",
                  "Transparent feedback loops"
                ].map((item, idx) => (
                  <div key={idx} className="flex items-center gap-4">
                    <CheckCircle2 className="w-5 h-5 text-brand-accent" />
                    <span className="text-lg font-bold text-brand-primary">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};
